export const LeanAppOverviewDataHooks = {
  BOX: 'lean-app-overview-box',
  APP_NAME: 'lean-app-overview-app-name',
  BENEFITS_LIST: 'lean-app-overview-benefits-list',
  LEARN_MORE_BUTTON: 'lean-app-overview-learn-more-button',
};
